import { Component, AfterViewInit, OnInit } from '@angular/core';
import * as projMsgs from '../../../../src/app/msg/projMsgs';
import * as aspSettings from '../asp/aspSettings';
import * as utils from '../common/utils';
import * as enums from '../common/enums';
import * as settings from '../common/settings';
import { AroService } from '../aro/aro.service';
import * as consts from '../common/consts';
import { METER_TO_FEET } from '@core_n/common/units';
import { MsgMngrService } from '../msg/msg-mngr.service';
import { AppInjector } from '@core_n/common/inject';
import { UserActionService } from '@core_n/user-action/user-action.service';
import { mainMapMngr } from '@core_n/asp/MapMngr';
import { userSettings } from '../common/settings';
import { PlaybackHandler } from 'src/app/asp/PlaybackHandler';
import { aspMngr } from '@core_n/asp/AspMngr';

//
// Coordinates Panel
//
@Component({
  selector: 'coord-panel',
  templateUrl: './coord-panel.component.html',
  styleUrls: ['./coord-panel.component.scss']
})
export class CoordinatesPanelComponent implements AfterViewInit, OnInit {
  public mapCoordinates: string;
  public mapHeight: string;
  

  //playback player
  private playbackHandler: PlaybackHandler = PlaybackHandler.getSelf();
  public isPlayback: boolean = false;
  private forwardSteps = [1, 2, 4];
  private currentSpeedIndex = 0;
  currentSpeedMultiplier='';
  showMultiplier = false;
  jumpTime = 0;
  newInterval: number;

  constructor(
    private aroService: AroService,
    private msgMngrServise: MsgMngrService
   ) {
  }

  ngAfterViewInit() {
    let self = this;
    setInterval(function () { self.refresh() }, 100); 
  }

  ngOnInit(): void {
     //playback status subject
     userSettings.isPlayback.subscribe(status => {
      this.isPlayback = status;
    });
  }
 
  private refresh(): void {
    if (aspSettings.mapCoordinate == null)
      this.mapCoordinates = null;
    else
      this.mapCoordinates = utils.getCoordinatesString(aspSettings.mapCoordinate);

    let isShowDTM = JSON.parse(localStorage.getItem(consts.LOCAL_STORAGE_SHOW_DTM_KEY));
    if (isShowDTM == true) {
      this.mapHeight = localStorage.getItem(consts.LOCAL_STORAGE_HEIGHT_KEY);
      if (this.mapHeight != 'undefined' && this.mapHeight != '') {
        if (settings.userSettings.displayUnits == settings.DisplayUnits.Imperial) {
          this.mapHeight = 'Height ' + (Number.parseInt(this.mapHeight) * METER_TO_FEET).toFixed(0).toString() + ' Feet';
        }
        else {
          this.mapHeight = 'Height ' + this.mapHeight + ' Meters';
        }
      }
      else {
        this.mapHeight = 'Height -'
      }
    }
    else {
      this.mapHeight = '';
      localStorage.setItem(consts.LOCAL_STORAGE_HEIGHT_KEY, '');
    }
  }

  public onCoordClick() {
    if (settings.userSettings.coordinatesType == enums.CoordinateType.WGS84_DMM)
      settings.userSettings.setCoordinatesType(enums.CoordinateType.WGS84_DMS);
    else if (settings.userSettings.coordinatesType == enums.CoordinateType.WGS84_DMS)
      settings.userSettings.setCoordinatesType(enums.CoordinateType.UTM);
    else if (settings.userSettings.coordinatesType == enums.CoordinateType.UTM)
      settings.userSettings.setCoordinatesType(enums.CoordinateType.WGS84_DMM);
    else
      return;
    this.aroService.updateLocation();
  }

  //playback player handle:
  handleJumpBackward(): void {

    this.jumpTime = -30;
    const speed = this.forwardSteps[this.currentSpeedIndex]
    this.playbackSpeedRequest(this.jumpTime, speed);
    this.playbackHandler.jumpTime(this.jumpTime);
    console.log(`Jumped backward ${this.jumpTime} seconds`);   
  }

  handleJumpForward(): void {

    this.jumpTime = 30;
    const speed = this.forwardSteps[this.currentSpeedIndex]
    this.playbackSpeedRequest(this.jumpTime, speed);
    this.playbackHandler.jumpTime(this.jumpTime);
    console.log(`Jumped forward +${this.jumpTime} seconds`);      
  }

  handleSpeedForward(): void {

    this.currentSpeedIndex = (this.currentSpeedIndex+1) % this.forwardSteps.length;
    const speed = this.forwardSteps[this.currentSpeedIndex];
    this.jumpTime = 0;
   
    if(speed === 1){
      this.currentSpeedMultiplier = ''
      this.showMultiplier = false;
      this.playbackHandler.resetPlaybackSpeed();
     
    }else {
      this.currentSpeedMultiplier = `x${speed}`
      this.showMultiplier = true;
      this.playbackHandler.setPlaybackSpeed(speed);
      this.playbackSpeedRequest(this.jumpTime , speed);
    }
    
    console.log(`Playback speed set to:  x${speed}`);
  }

  handleStopPlayback() {  
    
    this.currentSpeedIndex = this.forwardSteps[0];
    this.currentSpeedMultiplier = '';
    this.jumpTime = 0;
    let Msg = new projMsgs.StartPlaybackMode()
    Msg.dateTime = 0;
    AppInjector.get(UserActionService).sendUserAction(Msg); 
    userSettings.isPlayback.next(false);
    aspMngr.deleteAllObjects();
    mainMapMngr.clearObjects();
    console.log("stoping playback mode");
  }

  playbackSpeedRequest(jump: number, speed: number) {

    mainMapMngr.clearObjects(); 
    let Msg = new projMsgs.PlaybackSpeedMode()
    Msg.Jump = jump;
    Msg.PlayBackSpeed = speed;
    AppInjector.get(UserActionService).sendUserAction(Msg); 
  }
}
